<form [formGroup]="formDetalhe">
  <div class="row">
    <div class="form-group col-md-4">
      <label>Mês/Ano Referência<span style="color: red;">*</span></label>
      <input id="dtFim" formControlName="mesReferencia" type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Valor Royalties a Distribuir:<span style="color: red;">*</span></label>
      <input id="valorDistribuido" appCurrencyMask placeholder="R$ 0,00" inputmode="numeric" maxlength="17" formControlName="valorDistribuido" type="text" class="form-control">

<!-- Mensagens -->
<ng-container *ngIf="formDetalhe.controls && formDetalhe.controls.valorDistribuido as c">
  <div class="text-danger" *ngIf="c.touched && c.errors">
    <div *ngIf="c.errors.required">Informe um valor.</div>
    <div *ngIf="c.errors.minPtBR">O valor deve ser no mínimo 0,01.</div>
    <div *ngIf="c.errors.invalidCurrency">Valor inválido. Use o formato 1.234,56.</div>
  </div>
</ng-container>

    </div>
  </div>
</form>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirmar()">
      Salvar
    </button>
    <button type="button" class="btn btn-secondary" (click)="fechar()">
      Cancelar
    </button>
  </div>
<style>
  .aslib-grid-wrapper{
    margin-bottom: 0px !important;
  }
  .form-group {
    margin-bottom: 0.5rem !important;
  }
  </style>


// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/detalhe-valor-mensal-distribuir/detalhe-valor-mensal-distribuir.component.html